import React from 'react'
import { Button } from '@afterpaytouch/core'

import { DetailedItemList, Header, PaymentMethod, Summary, Terms } from './components'
import { useOnConfirmButtonClick } from './hooks'
import { useTranslation } from '../../utils/convergence'

export const AppleRetailSummaryPage = (): JSX.Element => {
  const { t } = useTranslation()
  const onConfirmButtonClick = useOnConfirmButtonClick()

  return (
    <>
      <Header />
      <DetailedItemList />
      <PaymentMethod />
      <Summary />
      <Terms />
      <Button size={'Large'} padding='Fluid' data-dd-action-name='Confirm Checkout' onClick={onConfirmButtonClick}>
        {t('summary:cta')}
      </Button>
    </>
  )
}
